import ModalBase, { IModalBaseProps, ModalBaseRefType } from "@/Components/Base/ModalBase";
import { TypePessoa } from "@/Models/Pessoa/Pessoa";
import PessoaBloqueio from "@/Models/Pessoa/PessoaBloqueio";
import { StopOutlined } from "@ant-design/icons";
import { Button, Collapse, Divider, Form, FormProps, Input, notification, Typography } from "antd";
import BloqueioTipoSelect from "./BloqueioTipo/BloqueioTipoSelect";
import { usePessoaBloquear, usePessoaBloqueioAtual } from "@/Services/Pessoa/PessoaBloqueioService";
import { useEffect, useRef } from "react";
import BloqueioItemForm from "./Item/BloqueioItemForm";
import BloqueioItemTable from "./Item/BloqueioItemTable";
import { EnumBloqueioTipo } from "@/Models/Pessoa/Bloqueio/BloqueioTipo";
import { PropriedadesDeNotificacao } from "@/Utils/Notificacoes";

const { TextArea } = Input;
const { Text } = Typography;

export interface IPessoaBloqueioBloquearModalProps extends Omit<IModalBaseProps, "children"> {
    formProps ?: Omit<FormProps<PessoaBloqueio>, "children">;
    pessoa : TypePessoa;
    onSuccess ?: Parameters<typeof usePessoaBloquear>[0]["onSuccess"];
}

export default function PessoaBloqueioBloquearModal ({ 
    formProps,
    pessoa,
    onSuccess,
    ...props
}:IPessoaBloqueioBloquearModalProps) {
    const component = formProps?.component ?? "div";
    const layout = formProps?.layout ?? "vertical";
    const autoComplete = formProps?.autoComplete ?? "off";

    const [form] = Form.useForm<PessoaBloqueio>();
    const codBloqueioTipoFormValue = Form.useWatch(["codBloqueioTipo"], form);

    const refModal = useRef<ModalBaseRefType|null>(null);

    const {
        mutate,
        isPending
    } = usePessoaBloquear({
        onSuccess(data, variables, context) {
            onSuccess?.(data, variables, context);
            refModal?.current?.fechar();
            notification.open({
                ...PropriedadesDeNotificacao.Sucesso("Bloqueio salvo com sucesso.")
            })
        }
    });

    const {
        data
    } = usePessoaBloqueioAtual({
        codPessoa : pessoa?.codigo ?? 0,
        codBloqueioTipo : codBloqueioTipoFormValue ?? 0,
        enabled : (pessoa?.codigo ?? 0) > 0 && (codBloqueioTipoFormValue ?? 0) > 0
    });

    useEffect(() => {
        if (!!data)
            form.setFieldsValue(data);
        else {
            form.resetFields();
            form.setFieldValue("codBloqueioTipo", codBloqueioTipoFormValue ?? undefined);
        }
    }, [data]);

    return <ModalBase
        title="Bloquear Manual"
        textButtonOpen="Bloq. Manual"
        propsButtonOpen={{
            danger : true,
            icon : <StopOutlined />
        }}
        width={"65vw"}
        ref={refModal}
        confirmLoading={isPending}
        onOk={() => form.submit()}
        destroyOnClose={true}
        {...props}
    >
        <Form
            {...formProps}
            component={component}
            layout={layout}
            autoComplete={autoComplete} 
            form={form}
            onFinish={(values) => {
                values.codPessoa = pessoa.codigo ?? 0;
                values.pessoa = pessoa;
                mutate(values);
            }}
        >
            <div>
                <Text strong type={data ? "danger" : "success"}>Situacao Atual do bloqueio manual: {data ? "Bloqueado" : "Desbloqueado"}</Text>
            </div>

            <Text strong>Nome: </Text>
            <Text>{pessoa.nomeExibicao}</Text>
            <Form.Item<PessoaBloqueio> name="codBloqueioTipo" label="Tipo" initialValue={EnumBloqueioTipo.Manual} hidden rules={[{ required : true }]} >
                <BloqueioTipoSelect value={EnumBloqueioTipo.Manual} />
            </Form.Item>

            {(codBloqueioTipoFormValue ?? 0) > 0 && <>
                <Divider style={{ marginTop : 10, marginBottom : 10 }} />

                <Form.Item<PessoaBloqueio> name="motivo" label="Motivo" rules={[{ max : 1000 }]} >    
                    <TextArea
                        placeholder="Motivo"
                        autoSize={{ minRows: 3, maxRows: 5 }}
                        maxLength={1000}
                    />
                </Form.Item>
            </>}
        </Form>
        {/* {
            data && <Collapse
                items={[
                    {
                        key : '1',
                        label : 'Pendências',
                        children : <BloqueioItemTable 
                            codBloqueio={data?.codigo ?? 0} 
                            codBloqueioTipo={data.codBloqueioTipo == EnumBloqueioTipo.Manual ? "Manual" : "Inadimplencia"} 
                        />
                    }
                ]}    
            />
        } */}
    </ModalBase>;
}

